<!--
 * @Description: 供应商销售排行榜
 * @Author: xiawenlong
 * @Date: 2021-07-13 09:17:17
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-05-07 08:50:18
-->

<template>
  <div class="SupplierSales">
    <div class="title">
      <span>供应商销售排行榜</span>
    </div>
    <vue-seamless-scroll :data="data" :class-option="scrollOption" class="ranking-list">
      <div
        v-for="(item, index) in data"
        :key="index"
        class="ranking-item"
        :class="'item' + (index + 1)"
        :style="{ animationDelay: `${index * 0.05}s` }"
      >
        <div class="rank-badge">{{ index + 1 }}</div>
        <img src="@/img/agriculture/arrow.png" alt="" />
        <div class="info-wrapper">
          <div class="name">{{ item.orgName }}({{ item.amount }}万元)</div>
          <div class="progress-bar">
            <div
              class="progress-fill"
              :style="{ width: getProgressWidth(item.amount) + '%' }"
            ></div>
          </div>
        </div>
      </div>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import { supplierSale } from '@/api/agriculture-dashboard'
import to from 'await-to'

export default {
  data() {
    return {
      scrollOption: {
        step: 0.6,
        limitMoveNum: 4,
        hoverStop: true,
        direction: 1,
        openWatch: true,
        singleHeight: 0,
        singleWidth: 0,
        waitTime: 0,
      },
      type: 3,
      maxAmount: 9256,
      data: [
        { orgName: '湖北可大农业发展有限公司', amount: 209.9 },
        { orgName: '湖北楚香园生态农业开发有限公司', amount: 209.9 },
        { orgName: '湖北红仓丰农业科技有限公司', amount: 209.9 },
        { orgName: '河南天目四望茶业有限公司', amount: 209.9 },
        { orgName: '湖北荆楚礼商贸有限责任公司', amount: 209.9 },
      ],
    }
  },
  mounted() {
    this.initData()
    setInterval(() => {
      this.initData()
    }, process.env.VUE_APP_LTIME)
  },
  methods: {
    async initData() {
      const [res, err] = await to(
        supplierSale({
          type: this.type,
        }),
      )
      if (err) return
      this.data = res.data
      this.maxAmount = Math.max(...res.data.map(item => item.amount))
    },
    typeChange(type) {
      this.type = type
      this.initData()
    },
    getProgressWidth(amount) {
      if (this.maxAmount === 0) return 0
      return (amount / this.maxAmount) * 100
    },
  },
}
</script>

<style lang="scss" scoped>
.SupplierSales {
  position: relative;
  height: 100%;
  box-sizing: border-box;

  .title {
    position: relative;
    width: 100%;
    height: 70px;
    background: url('~@/img/agriculture/title_bg.png') 100% 100%;
    border-radius: 7px 7px 0px 0px;
    font-weight: bold;
    font-size: 30px;
    color: #fefefe;
    line-height: 70px;
    padding-left: 47px;

    span {
      position: relative;
      z-index: 9;
    }

    &::after {
      z-index: 8;
      content: '';
      position: absolute;
      left: 25px;
      bottom: 5px;
      width: 366px;
      height: 23px;
      background: url('~@/img/agriculture/title_line.png') 100% 100%;
    }
  }

  .ranking-list {
    box-sizing: border-box;
    padding: 10px 20px;
    overflow-y: auto;
    height: calc(100% - 70px);

    &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;

    .ranking-item {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      animation: slideInLeft 0.5s ease-out forwards;
      opacity: 0;
      position: relative;

      .rank-badge {
        width: 23px;
        height: 20px;
        min-width: 23px;
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        color: #fff;
        background: #448aff;
      }

      img {
        width: 22px;
        height: 23px;
        margin-right: 10px;
      }

      .info-wrapper {
        flex: 1;
        min-width: 0;

        .name {
          font-size: 18px;
          color: #ffffff;
          font-weight: 500;
          line-height: 28px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-bottom: 6px;
        }

        .progress-bar {
          width: 100%;
          height: 10px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 3px;
          overflow: hidden;

          .progress-fill {
            height: 100%;
            border-radius: 3px;
            transition: width 0.8s ease;
            background: #448aff;
          }
        }
      }

      &.item1 .rank-badge,
      &.item1 .progress-fill {
        background: #ff4444;
      }

      &.item2 .rank-badge,
      &.item2 .progress-fill {
        background: #ff8c00;
      }

      &.item3 .rank-badge,
      &.item3 .progress-fill {
        background: #ffd700;
      }

      &.item4 .rank-badge,
      &.item4 .progress-fill {
        background: #448aff;
      }

      &.item5 .rank-badge,
      &.item5 .progress-fill {
        background: #448aff;
      }
    }
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
